import { defineAsyncComponent } from 'vue';

import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Recently Viewed Homes Vue Component');
    app.vueApp.component(
        'recently-viewed-homes',
        defineAsyncComponent(async () => import('./RecentlyViewedHomes.vue'))
    );
    app.vueApp.component('recently-viewed-products-writer', defineAsyncComponent(async () => import('./RecentlyViewedProductsWriter.vue')));
};